/**
 * Default Shopware 6.6 PDP measurement strategy pack: ordered list used by `measurementListeners` so new
 * concerns (or shop-specific selectors) can be added as isolated strategy classes.
 *
 * Plugin coverage: aggregate of the strategies returned here — each class documents which Store plugins /
 * DOM patterns it targets; adjust order only if one strategy must observe before another (rare).
 */
import type { PdpMeasurementStrategy } from './PdpMeasurementStrategy';
import { DefaultShopware66CoreStrategy } from './DefaultShopware66CoreStrategy';
import { GalleryImageClickStrategy } from './GalleryImageClickStrategy';
import { GallerySlideViewedStrategy } from './GallerySlideViewedStrategy';
import { GalleryZoomStrategy } from './GalleryZoomStrategy';
import { RecommendationsReachedStrategy } from './RecommendationsReachedStrategy';
import { ReviewsReachedStrategy } from './ReviewsReachedStrategy';
import { ThreeSixtyGalleryStrategy } from './ThreeSixtyGalleryStrategy';
import { VariantInteractionStrategy } from './VariantInteractionStrategy';

export type { PdpMeasurementStrategy } from './PdpMeasurementStrategy';
export { PdpMeasurementStrategyComposite } from './PdpMeasurementStrategyComposite';

export function createShopware66PdpMeasurementStrategies(): PdpMeasurementStrategy[] {
  return [
    new DefaultShopware66CoreStrategy(),
    new VariantInteractionStrategy(),
    new GalleryImageClickStrategy(),
    new GallerySlideViewedStrategy(),
    new ThreeSixtyGalleryStrategy(),
    new GalleryZoomStrategy(),
    new ReviewsReachedStrategy(),
    new RecommendationsReachedStrategy(),
  ];
}
